var $ = global.jQuery = global.$;
var _Slider = require('./_Slider');
var _merge = require('lodash/object/merge');

/**
 * Slider widget that implements Slick slider with some default options
 * @class
 * @extends _Slider
 */
var CommentSlider = _Slider.extend(
  /** @lends CommentSlider.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  onWidgetsReady: function() {
    var self = this;

    var options = {
      prevArrow: '<button class="comment-slider__arrow comment-slider__arrow--prev"><span class="a11y">Previous</span></button>',
      nextArrow: '<button class="comment-slider__arrow comment-slider__arrow--next"><span class="a11y">Next</span></button>'
    };

    this.options = _merge(this.options, options);

    this._super();
  }
});

module.exports = CommentSlider;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/CommentSlider.js
// module id = 298
// module chunks = 0